module.exports = __webpack_public_path__ + "static/media/Integration.cb39b8e7.png";